import React, { Component } from 'react';
import queryString from 'query-string';
import firebase from 'firebase/app';
import shuffle from 'shuffle-array';
import axios from 'axios';
import { firebaseApp } from './firebase/';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Jumbotron from 'react-bootstrap/Jumbotron'
import Badge from 'react-bootstrap/Badge';
import { ToastContainer, toast } from 'react-toastify'
import { ClozeReader, ClozeTest, Quiz, SelfEval, BidirectionalTest, ClozeContent } from 'cogsche-task';
import ClipLoader from "react-spinners/ClipLoader";
import QRCode from 'qrcode.react'

import {
  SignInButtons,
  saveSignInParam,
  createGoogleAuthProvider,
  onAuthStateChanged,
  inLTIContext,
} from './task/SignInButtons'
import UserNavbar from './task/UserNavbar'
import SideNavbar from './task/SideNavbar'
import { TimeNavbar, computeDuration } from './task/TimeNavbar'
import ContentAlert from './task/ContentAlert'
import YouTubeLink from './task/YouTubeLink'
import ContentLinks from './task/ContentLinks'
import Description from './task/Description'
import Agreement, { checkAgreement } from './common/Agreement'
import UnauthorizedUser from './common/UnauthorizedUser'
import Footer from './task/Footer'
import { arrangeQuiz, updateQuizScore, updateTaskRefQuizAccess } from './task/QuizArranger'
import ResetContextDialog from './task/ResetContextDialog'
import { setLocalStorageItem } from './common/LocalStorage'
import Runner from './common/Runner';

import 'rc-slider/assets/index.css';
import 'cogsche-task/dist/index.css'
import './App.css';


const SENTENCE_INTERVAL = 4
const DEFAULT_MISSING_COUNT = 2;
const FREQUENCY_LTI_RECORD_MSEC = 1000 * 20; // 最多で毎分3回ログを記録

const db = firebaseApp.firestore();
const storage = firebaseApp.storage()

export function postMessageToParent(message) {
  if (!window.parent) {
    console.log('Post Message(no parent)', message);
    return;
  }
  window.parent.postMessage(message, '*');
}

class App extends Component {
  constructor(props) {
    super(props);

    this._input = null;
    this.state = {
      user: null,
      require_auth: false,
      whitelist_auth: null,
      task_id: null,
      my_id: '',
      loading: true,
      data: null,
      error: null,
      taskError: null,
      context_id: null,
      finished: false,
      aborted: false,
      reader: false,
      quiz: false,
      selfeval: false,
      v2: false,
      answers: null,
      cloze_selection: false,
      exp: false,
      evaluation: null,
      progress: null,
      report: null,
      incompleteTasks: null,
      lastContext: null,
      links: null,
      needAgreement: false,
      statementAlreadyOpened: false,
      additionalLinks: null,
      startedTime: null,
      elapsedStarted: null,
      elapsedDuration: 0,
      elapsedLastActionAt: null,
    }
    this.clozev2Ref = React.createRef()
    this.ltiRunner = new Runner(FREQUENCY_LTI_RECORD_MSEC);
  }

  copyState() {
    return Object.assign({}, this.state);
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  get query() {
    return this.props.query || queryString.parse(window.location.search);
  }

  get db() {
    return this.props.db || db
  }

  get storage() {
    return this.props.storage || storage
  }

  componentDidMount() {
    postMessageToParent({
      event: 'loading',
    });
    const query = this.query;
    if (!query.task_id) {
      const state = this.copyState();
      state.loading = false;
      state.task_id = null;
      this.setState(state, () => {
        this.loadUser()
      });
      const ltisession = query.ltisession || null;
      postMessageToParent({
        event: 'loaded',
        ltisession,
      });
      return;
    }
    const clozeSelection = query.sel && parseInt(query.sel) === 1;
    this.loadTask(query.task_id, clozeSelection, query.v2, query.quiz || query.selfeval || false)
      .then(task => {
        console.log('Loaded', task);
        const state = this.copyState();
        state.task_id = query.task_id;
        state.exp = query.exp && parseInt(query.exp) === 1
        state.reader = query.reader && parseInt(query.reader) === 1;
        if (!state.reader) {
          state.quiz = query.quiz && parseInt(query.quiz) === 1;
        }
        if (!state.reader && !state.quiz) {
          state.selfeval = query.selfeval && parseInt(query.selfeval) === 1;
        }
        if (!state.reader && !state.quiz && !state.selfeval) {
          state.v2 = query.v2 && parseInt(query.v2) === 1;
        }
        try {
          const clozev2store = localStorage.getItem(`clozev2.${state.task_id}`)
          if (clozev2store) {
            state.clozev2store = JSON.parse(clozev2store)
          }
          const clozev2hint = localStorage.getItem('clozev2.hint')
          if (clozev2hint) {
            state.clozev2hint = JSON.parse(clozev2hint)
          } else {
            state.clozev2hint = {}
          }
        } catch(e) {
          console.warn('Cannot access localStorage', e);
          state.disableLocalStorage = true;
        }

        state.cloze_selection = clozeSelection;
        state.data = task.data;
        state.require_auth = task.require_auth || false;
        state.whitelist_auth = task.whitelist_auth || null
        state.importable = task.importable || false
        state.evaluation = task.evaluation || null
        state.title = task.title || null;
        state.description = task.description || null;
        state.theme = task.theme || 'default'
        state.links = task.links ? JSON.parse(task.links) : {}
        state.disable_word_click = task.disable_word_click || false
        state.filtered_query = task.filtered_query;
        state.autoStart = query.auto_start === 'true';
        state.ltiInProgress = (query.lti_mode || '').includes('inprogress');
        const ltisession = query.ltisession || null;
        state.ltisession = ltisession;
        this.setState(state, () => {
          this.loadUser(task)
          postMessageToParent({
            event: 'loaded',
            ltisession,
          });
        });
      })
      .catch(error => {
        this.showError(error);
      });
  }

  componentWillUnmount() {
    this.ltiRunner.flush();
  }

  showError(error) {
    console.error(error)
    postMessageToParent({
      event: 'error',
    });
    this.setState({
      loading: false,
      error: error.message || error,
      taskError: error.message || error,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
    if (this._input) {
      this._input.focus();
    }
  }

  loadUser(task) {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.showError(error);
        return;
      }
      this.prepare(this.db, user, task)
        .then(({ contextId, needAgreement, agreement, userAgreement }) => {
          this.setState({
            loading: this.state.loading ? (user !== null) : false,
            user,
            my_id: user ? user.email : '',
            needAgreement,
            agreement,
            userAgreement,
            context_id: contextId,
          }, () => {
            if (!user) {
              return
            }
            this.loadIncompleteTasksAndAlerts(user)
          })
        })
        .catch(error => {
          this.showError(error)
        })
    })
  }

  isLastContext(context1, context2) {
    if (!context2) {
      return true
    }
    if (!context1) {
      return false
    }
    const updated1 = context1.updated
    const updated2 = context2.updated
    if (updated1 && updated2) {
      if (updated1 > updated2) {
        return true
      }
    }
    const selected1 = context1.selected
    const selected2 = context2.selected
    if (selected1.rowIndex > selected2.rowIndex) {
      return true
    }
    return selected1.beginIndex > selected2.beginIndex
  }

  getFirstRow(rowIndex) {
    const content = new ClozeContent(this.state.data);
    const pages = content.getPages();
    const rows = pages
      .map((page) => page.bounds.filter((bound) => bound.rowIndex === rowIndex))
      .reduce((x, y) => x.concat(y), []);
    if (rows.length === 0) {
      console.warn('rowIndex not found', rowIndex);
      return null;
    }
    return rows[0];
  }

  getPreferContext(result) {
    const baseContext = this.isLastContext(result.lastContext, this.state.clozev2store) ? result.lastContext : this.state.clozev2store;
    const { filtered_query } = this.state;
    if (!filtered_query) {
      return baseContext;
    }
    if (filtered_query.filter) {
      return baseContext;
    }
    if (!filtered_query.ignoredStartRowIndex) {
      return baseContext;
    }
    const row = this.getFirstRow(filtered_query.ignoredStartRowIndex);
    if (row === null) {
      return null;
    }
    const { rowIndex, beginIndex } = row;
    if (!baseContext) {
      return {
        updated: Date.now(),
        selected: {
          rowIndex,
          beginIndex,
        },
        answers: [],
        activities: [],
      };
    }
    baseContext.selected = {
      rowIndex,
      beginIndex,
    };
    return baseContext;
  }

  loadIncompleteTasksAndAlerts(user) {
    this.performLoadIncompleteTasksAndAlerts(user)
      .then(result => {
        const clozev2store = this.getPreferContext(result);
        this.setState({
          loading: false,
          incompleteTasks: result.incompleteTasks,
          alerts: result.alerts,
          data: result.data,
          clozev2store,
        })
      })
      .catch(error => {
        console.error(error)
        this.setState({
          error: error.message || error
        })
      })
  }

  async loadAlerts(user) {
    const publicAlerts = await this.db
      .collection('alert')
      .where('public', '==', true)
      .get()
    const domainAlerts = user.email.includes('@') ? (await this.db
      .collection('alert')
      .where('domain', '==', user.email.substring(user.email.indexOf('@')))
      .get()) : { docs: [] }
    const serializeAlert = (alert) => ({
      id: alert.id,
      variant: alert.data().variant,
      title: alert.data().title,
      message: alert.data().message,
      visible: alert.data().visible,
    })
    return domainAlerts.docs.map(serializeAlert)
      .concat(publicAlerts.docs.map(serializeAlert))
      .filter((alert) => alert.visible)
  }

  async performLoadIncompleteTasksAndAlerts(user) {
    const userRef = await this.db
      .collection('user').doc(user.uid).get()
    await saveSignInParam(this.db.collection('user'), userRef)
    let taskData = this.state.data
    if (this.state.quiz) {
      taskData = Object.assign({}, taskData)
      taskData.quiz = await arrangeQuiz(this.db, this.state.task_id, user.uid, taskData.quiz)
    }
    const taskRefs = await this.db
      .collection('user').doc(user.uid)
      .collection('taskref').where('completed', '==', false).get()
    var lastTaskRef = null;
    if (this.state.task_id) {
      lastTaskRef = await this.db
        .collection('user').doc(user.uid)
        .collection('taskref').doc(this.state.task_id)
        .get()
    }
    const alerts = await this.loadAlerts(user)
    return {
      data: taskData,
      incompleteTasks: taskRefs.docs.map(taskRef => ({
        id: taskRef.id,
        data: taskRef.data(),
      })),
      alerts,
      lastContext: (lastTaskRef && lastTaskRef.exists && lastTaskRef.data().lastContext) ?
        JSON.parse(lastTaskRef.data().lastContext) : null,
    }
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  toQuizWord(text, correct, incorrects) {
    const incorrects_ = [...incorrects]
    shuffle(incorrects_)
    const answerIndex = Math.floor(Math.random() * Math.floor(4))
    const answers = incorrects_
      .slice(0, answerIndex)
      .concat([correct])
      .concat(incorrects_.slice(answerIndex))
    return {
      text,
      answerIndex,
      answers: answers.slice(0, 4).map(a => ({
        text: a
      })),
    }
  }

  toQuiz(words) {
    if (!words) {
      return []
    }
    shuffle(words)
    return words
      .filter(row => row.length > 2)
      .map((row) => this.toQuizWord(row[0], row[1], row.slice(2)))
  }

  parseFilterQuery(q) {
    if (!q) {
      return null;
    }
    const pageMatcher = q.match(/^p:([0-9]+)$/);
    if (pageMatcher) {
      return {
        pageIndex: parseInt(pageMatcher[1]),
      };
    }
    const rowMatcher = q.match(/^([0-9]+)$/);
    if (rowMatcher) {
      return {
        rowIndex: parseInt(rowMatcher[1]),
      };
    }
    return null;
  }

  filterRowsByRange(list, startRow, endRow) {
    return list
      .map((row, rowIndex) => [row, rowIndex])
      .filter(rowWithIndex => startRow === null || rowWithIndex[1] >= startRow)
      .filter(rowWithIndex => endRow === null || rowWithIndex[1] < endRow)
      .map(rowWithIndex => rowWithIndex[0]);
  }

  getRowIndexFromQuery(query, pages) {
    if (!query) {
      return null;
    }
    if (query.rowIndex !== undefined) {
      return query.rowIndex;
    }
    if (query.pageIndex !== undefined) {
      return pages[query.pageIndex] ? pages[query.pageIndex].rowIndex : null;
    }
    return null;
  }

  filterRows(task) {
    const { start, end, filter } = this.query;
    if (!start && !end) {
      return null;
    }
    const startQ = this.parseFilterQuery(start);
    const endQ = this.parseFilterQuery(end);
    if (!startQ && !endQ) {
      return null;
    }
    const content = new ClozeContent(task.data);
    const pages = content.getPages();
    const startRow = this.getRowIndexFromQuery(startQ, pages);
    const endRow = this.getRowIndexFromQuery(endQ, pages);
    if (filter !== 'true') {
      return {
        rows: task.data.rows,
        chunks: task.data.chunks,
        query: {
          filter: false,
          ignoredStartPageIndex: startQ ? startQ.pageIndex : null,
          ignoredEndPageIndex: endQ ? endQ.pageIndex : null,
          ignoredStartRowIndex: startRow,
          ignoredEndRowIndex: endRow,
          originalTaskData: Object.assign({}, task.data),
        }
      }
    }
    return {
      rows: this.filterRowsByRange(task.data.rows, startRow, endRow),
      chunks: this.filterRowsByRange(task.data.chunks, startRow, endRow),
      query: {
        filter: true,
        startPageIndex: startQ ? startQ.pageIndex : null,
        endPageIndex: endQ ? endQ.pageIndex : null,
        startRowIndex: startRow,
        endRowIndex: endRow,
        originalTaskData: Object.assign({}, task.data),
      }
    };
  }

  getStatementsSpan() {
    const { statements_span, sspan } = this.query;
    const statementsSpan = statements_span || sspan;
    if (!statementsSpan) {
      return 0;
    }
    if (!statementsSpan.match(/^[0-9]+$/)) {
      console.warn(`Unexpected statementsSpan. Ignored.: ${statementsSpan}`);
      return 0;
    }
    return parseInt(statementsSpan);
  }

  getMaximumMissing(task) {
    const { missing_count, noblank } = this.query;
    if (noblank === null) {
      return 0;
    }
    if (!missing_count) {
      return DEFAULT_MISSING_COUNT;
    }
    return parseInt(missing_count);
  }

  arrangeTask(task, clozeSelection, v2, requireExamples) {
    task.data.quiz = this.toQuiz(task.data.words);
    if (!clozeSelection && (!task.updated || task.updated < 1593475200000 /*temp*/)) {
      task.data.rows = task.data.rows
        .map(row =>
          row.map(cell =>
            cell.split('|').length > 1 ? `${cell.split('|')[0]}|*` : cell));
    }
    const filtered = this.filterRows(task);
    if (filtered) {
      task.data.rows = filtered.rows;
      task.data.chunks = filtered.chunks;
      task.filtered_query = filtered.query;
    }
    if (v2 && task.updated < 1593327318000 /*temp*/) {
      const lines = []
      let sentenceIndex = 0
      task.data.rows.forEach((row, rowIndex) => {
        const line = []
        row.forEach((cell, cellIndex) => {
          line.push(sentenceIndex)
          if (cell === '.') {
            sentenceIndex ++
          }
        })
        lines.push(line)
      })
      task.data.rows = task.data.rows.map((row, rowIndex) => {
        return row.map((cell, cellIndex) => {
          const index = lines[rowIndex][cellIndex]
          if (index % SENTENCE_INTERVAL > 0) {
            return cell
          }
          if (!cell.endsWith('|*')) {
            return cell
          }
          return cell.substring(0, cell.length - 2)
        })
      })
    }
    if (task.choice_counts === 0) {
      return task;
    }
    task.data.examples = {}
    task.data.rows.forEach(row => {
      const sentences = []
      let sentenceIndex = 0
      row.forEach((cell, cellIndex) => {
        sentences.push(sentenceIndex)
        if (cell === '.' || cell === '!' || cell === '?') {
          sentenceIndex ++
        }
      });
      if (requireExamples) {
        [...Array(sentenceIndex + 1).keys()].forEach(sidx => {
          let cells = row.map((cell, index) => [cell, index])
            .filter(cellc => sentences[cellc[1]] === sidx)
            .map(cellc => cellc[0].split('|')[0])
          if (cells.length > 0 && cells[0].startsWith('!')) {
            cells = cells.slice(1)
          }
          const words = [...new Set(cells.concat(cells.map(cell => cell.toLowerCase())))]
          words.forEach(word => {
            if (!word.match(/^[a-zA-Z]+$/)) {
              return
            }
            if (task.data.examples[word]) {
              task.data.examples[word].push(cells)
            } else {
              task.data.examples[word] = [cells]
            }
          })
        })
      }
      const statementsSpan = this.getStatementsSpan();
      let nextSentenceIndex = 0;
      [...Array(sentenceIndex + 1).keys()].forEach(sidx => {
        const scells = row.map((cell, index) => [cell, index])
          .filter(cellc => sentences[cellc[1]] === sidx)
        const cells = scells.filter(cellc => cellc[0].split('|').length > 1)
        if (cells.length === 0) {
          return
        }
        if (sidx < nextSentenceIndex) {
          // 穴埋め問題を出題したばかりなので出題をやめる
          cells.forEach(cell => {
            const cellText = row[cell[1]]
            row[cell[1]] = cellText.split('|')[0]
          })
          return
        }
        let choiceCounts = parseInt(scells.length / task.choice_counts);
        shuffle(cells)
        // 隣接している項目を空欄から除外(cellsの先頭を優先して除外)
        cells.filter((cellc, index) => cells.slice(index + 1)
          .some(cc => cellc[1] === cc[1] - 1 || cellc[1] === cc[1] + 1))
        .forEach(cell => {
          row[cell[1]] = cell[0].split('|')[0];
        });
        // 難易度調整 ... cellsの後ろを残して除外
        cells.slice(0, Math.max(cells.length - choiceCounts, 0)).forEach(cell => {
          row[cell[1]] = cell[0].split('|')[0];
        });
        // 先頭だけ残す
        let maxMissing = this.getMaximumMissing(task);
        if (maxMissing !== null) {
          cells.forEach(cell => {
            const cellText = row[cell[1]];
            if (cellText.split('|').length === 1) {
              return;
            }
            if (maxMissing <= 0) {
              row[cell[1]] = cellText.split('|')[0];
            }
            maxMissing --;
          });
        }
        // 次の出題タイミングを調整する
        nextSentenceIndex = sidx + statementsSpan + 1;
      })
    })
    return task;
  }

  async loadTask(taskId, clozeSelection, v2, requireExamples) {
    const task = await this.db.collection('task').doc(taskId).get();
    if (!task.exists) {
      throw new Error(`タスクが見つかりません: ${taskId}`);
    }
    const r = Object.assign({}, task.data());
    r.data = JSON.parse(task.data().data);
    r.choice_counts = r.choice_counts || 0;
    return this.arrangeTask(r, clozeSelection, v2, requireExamples);
  }

  async prepare(db, user, task) {
    const agreement = await checkAgreement(db, user, task)
    if (!this.canAccess(user)) {
      return agreement
    }
    const context = await db
      .collection('context')
      .add({
        started: Date.now(),
        task: this.state.task_id,
        user_id: user ? user.email : '',
      });
    return Object.assign({ contextId: context.id }, agreement);
  }

  start() {
    const state = this.copyState();
    state.started = true;
    state.startedTime = Date.now();
    this.setState(Object.assign(state, this.restoreTimerStates()));
    postMessageToParent({
      event: 'started',
    });
  }

  async pushLog(taskType, data) {
    const currentTime = Date.now()
    await this.db.collection('log').add({
        finished: currentTime,
        type: taskType,
        task: this.state.task_id,
        user: this.state.my_id,
        data: JSON.stringify(data),
        stored: currentTime,
        errors: 0,
      })
    if (!this.state.user) {
      return null;
    }
    const added = await this.db
      .collection('user').doc(this.state.user.uid)
      .collection('log')
      .add({
        finished: currentTime,
        type: taskType,
        task: this.state.task_id,
        user: this.state.my_id,
        data: JSON.stringify(data),
      });
    return added.id;
  }

  log(taskType, content, callback) {
    this.pushLog(taskType, content)
      .then(data => {
        console.log('Sent', content);
        if (callback) {
          callback();
        }
      })
      .catch(error => {
        console.error(error);
        const state = this.copyState();
        state.loading = false;
        state.error = error.message || error;
        this.setState(state);
      });
  }

  async recordProgress(words, context, progress) {
    const duration = this.getDurationFromActivities(context.activities);
    const logId = await this.pushLog('clozereaderv2', {
      type: 'sentence',
      words,
      answers: context.answers,
      activities: context.activities,
      duration,
    })
    if (!this.state.user) {
      return { logId };
    }
    console.log('PROGRESS', context.answers, progress)
    const completed = progress.page.all > 1 ? (progress.page.current >= progress.page.all) : (progress.sentence.current >= progress.sentence.all)
    const rate = progress.page.all > 1 ? progress.page.current / progress.page.all : progress.sentence.current / progress.sentence.all
    let scoreTotal = 0
    let score = 0
    context.answers.forEach(answers => {
      answers.answers.forEach(answer => {
        answer.answer.forEach(a => {
          scoreTotal += a.result ? a.result.judge !== 'skipped' : 1
          score += a.result ? a.result.judge === 'correct' : 0
        })
      })
    })
    const taskRef = this.db
      .collection('user').doc(this.state.user.uid)
      .collection('taskref')
      .doc(this.state.task_id)
    const oldTaskRef = await taskRef.get()
    if (oldTaskRef.exists && oldTaskRef.data().rate > rate) {
      console.log('ALREADY exists')
      const taskRefData = Object.assign({}, oldTaskRef.data())
      taskRefData.accessed = Date.now()
      if (!this.isJustInitialized(context)) {
        taskRefData.lastContext = JSON.stringify(context)
      }
      await taskRef.set(taskRefData)
      return { logId };
    }
    if (oldTaskRef.exists && oldTaskRef.data().scoreTotal > 0 && scoreTotal > 0) {
      if (oldTaskRef.data().scoreTotal > scoreTotal) {
        scoreTotal = oldTaskRef.data().scoreTotal
        score = oldTaskRef.data().score
      } else if (oldTaskRef.data().score > score) {
        score = oldTaskRef.data().score
      }
    }
    const quizAccessed = oldTaskRef.exists ? (oldTaskRef.data().quizAccessed || null) : null
    await taskRef.set({
      valid: true,
      accessed: Date.now(),
      title: this.state.title,
      completed,
      rate,
      score,
      scoreTotal,
      quizAccessed,
      lastContext: JSON.stringify(context),
    });
    return { logId };
  }

  async recordContext(context) {
    if (!this.state.user) {
      return
    }
    const taskRef = this.db
      .collection('user').doc(this.state.user.uid)
      .collection('taskref')
      .doc(this.state.task_id)
    const oldTaskRef = await taskRef.get()
    if (!oldTaskRef.exists) {
      return
    }
    const lastData = Object.assign({}, oldTaskRef.data())
    lastData.lastContext = JSON.stringify(context)
    await taskRef.set(lastData)
  }

  reserveRecordLTIProgress(logId, context) {
    if (!this.state.ltiInProgress) {
      return;
    }
    if (!this.state.started) {
      return;
    }
    this.ltiRunner.reserve(() => this.recordLTIProgress(logId, context));
  }

  recordLTIProgress(logId, context) {
    const activities = context ? context.activities : null;
    const duration = this.getDurationFromActivities(activities);
    postMessageToParent({
      event: 'begin-store-progress',
    });
    this.performRecordLTIProgress(logId, 'clozereaderv2', {
      type: 'inprogress',
      answers: context ? context.answers : null,
      activities,
      progress: this.state.progress || null,
      duration,
    })
      .then(({ ltisession }) => {
        this.setState({
          ltisession: ltisession || this.state.ltisession,
        }, () => postMessageToParent({
          event: 'end-store-progress',
          ltisession: ltisession || this.state.ltisession,
        }));
      })
      .catch((error) => {
        postMessageToParent({
          event: 'error-store-progress',
          error,
        });
      });
  }

  async performRecordLTIProgress(lastLogId, taskType, allAnswers) {
    if (taskType !== 'clozereaderv2') {
      return {};
    }
    const logId = lastLogId ? lastLogId : (await this.pushLog(taskType, allAnswers));
    const r = await this.updateClozeTestScore(taskType, allAnswers, logId);
    if (!inLTIContext(this.state.user)) {
      return {};
    }
    return await this.sendGrade('InProgress');
  }

  async sendGrade(progress) {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    const ltik = params.get('ltik');
    const result = await axios.post(
      `/lti/users/${this.state.user.uid}/taskrefs/${this.state.task_id}?ltik=${ltik}`,
      {
        progress,
        ltisession: this.state.ltisession || null,
      },
    );
    return result.data;
  }

  async recordFinish(taskType, allAnswers) {
    const logId = await this.pushLog(taskType, allAnswers)
    console.log('FINISHED', allAnswers)
    if (taskType === 'quiz') {
      if (!this.state.user) {
        return null
      }
      await updateTaskRefQuizAccess(
        this.db, this.state.user.uid, this.state.task_id, new Date()
      )
      return await updateQuizScore(this.db, this.state.user.uid, allAnswers)
    }
    const r = await this.updateClozeTestScore(taskType, allAnswers, logId);
    if (!inLTIContext(this.state.user)) {
      return r;
    }
    await this.sendGrade('Completed');
    return r;
  }

  async updateClozeTestScore(taskType, allAnswers, logId) {
    if (!allAnswers.answers) {
      return null
    }
    const completed = true
    const rate = 1.0
    let scoreTotal = 0
    let score = 0
    allAnswers.answers.forEach(answers => {
      answers.answers.forEach(answer => {
        answer.answer.forEach(a => {
          scoreTotal += a.result ? a.result.judge !== 'skipped' : 1
          score += a.result ? a.result.judge === 'correct' : 0
        })
      })
    })
    if (!this.state.user) {
      return {
        score,
        scoreTotal,
      }
    }
    const currentScore = score
    const currentScoreTotal = scoreTotal
    const taskRef = this.db
      .collection('user').doc(this.state.user.uid)
      .collection('taskref')
      .doc(this.state.task_id)
    const oldTaskRef = await taskRef.get()
    if (oldTaskRef.exists && oldTaskRef.data().scoreTotal > 0 && scoreTotal > 0) {
      if (oldTaskRef.data().score > score) {
        scoreTotal = oldTaskRef.data().scoreTotal
        score = oldTaskRef.data().score
      }
    }
    const lastContext = oldTaskRef.exists ? (oldTaskRef.data().lastContext || null) : null
    const quizAccessed = oldTaskRef.exists ? (oldTaskRef.data().quizAccessed || null) : null
    await taskRef.set({
      valid: true,
      accessed: Date.now(),
      title: this.state.title,
      completed,
      rate,
      score,
      scoreTotal,
      quizAccessed,
      lastContext,
      latestLogId: logId,
    })
    return {
      score: currentScore,
      scoreTotal: currentScoreTotal,
    }
  }

  mergeAnswersOrActivities(a1, a2) {
    if (!a1) {
      return a2;
    }
    if (!a2) {
      return a1;
    }
    const a2new = a2.filter((elem2) => !a1
      .some((elem1) => elem1.rowIndex === elem2.rowIndex && elem1.beginIndex === elem2.beginIndex && elem1.time === elem2.time));
    const r = a1.concat(a2new);
    r.sort(function(a, b) {
      if (a.time < b.time) {
        return -1;
      }
      if (a.time > b.time) {
        return 1;
      }
      return 0;
    });
    return r;
  }

  mergeRelativeContext(relativeContext) {
    const absoluteContext = this.toAbsoluteContext(relativeContext);
    const baseContext = this.state.clozev2store;
    if (baseContext) {
      absoluteContext.answers = this.mergeAnswersOrActivities(baseContext.answers, absoluteContext.answers);
      absoluteContext.activities = this.mergeAnswersOrActivities(baseContext.activities, absoluteContext.activities);
    }
    const context = Object.assign({
      updated: Date.now(),
    }, absoluteContext);
    console.log('Merged', baseContext, relativeContext, context);
    return context;
  }

  evaluated(baseContext) {
    const context = this.mergeRelativeContext(baseContext);
    this.clozev2Store(context)
    this.setState({
      lastContext: context,
    }, () => {
      this.recordContext(context)
        .then(() => {
          console.log('Context recorded')
          this.reserveRecordLTIProgress(null, context);
        })
        .catch(error => {
          console.error(error);
          const state = this.copyState();
          state.loading = false;
          state.error = error.message || error;
          this.setState(state);
        })
    })
  }

  statementOpen(words, baseContext, progress, callback) {
    const hint = Object.assign({}, this.state.clozev2hint)
    if (this.state.statementAlreadyOpened && !hint['abort']) {
      hint['abort'] = false
    }
    const context = this.mergeRelativeContext(baseContext);
    this.clozev2Store(context)
    this.setState({
      progress,
      lastContext: context,
      clozev2hint: hint,
      statementAlreadyOpened: true,
    }, () => {
      this.recordProgress(words, context, progress)
        .then(({ logId }) => {
          if (callback) {
            callback();
          }
          this.reserveRecordLTIProgress(logId, context);
        })
        .catch(error => {
          console.error(error);
          const state = this.copyState();
          state.loading = false;
          state.error = error.message || error;
          this.setState(state);
        });
    })
  }

  abort() {
    postMessageToParent({
      event: 'aborting',
    });
    this.clozev2HintPerform('abort_resume')
    const context = this.state.lastContext || this.state.clozev2store
    const activities = context ? context.activities : null;
    const duration = this.getDurationFromActivities(activities);
    this.recordFinish('clozereaderv2', {
      type: 'abort',
      answers: context ? context.answers : null,
      activities,
      progress: this.state.progress || null,
      duration,
    })
      .then(data => {
        this.setState({
          finished: true,
          aborted: true,
        })
        postMessageToParent({
          event: 'aborted',
        });
      })
      .catch(error => {
        console.error(error);
        const state = this.copyState();
        state.loading = false;
        state.error = error.message || error;
        this.setState(state);
      })
  }

  finish(taskType, answers) {
    postMessageToParent({
      event: 'finishing',
    });
    this.recordFinish(taskType, answers)
      .then(data => {
        const state = this.copyState();
        state.loading = false;
        state.finished = true;
        state.answers = answers;
        state.score = data
        this.setState(state);
        postMessageToParent({
          event: 'finished',
        });
      })
      .catch(error => {
        console.error(error);
        const state = this.copyState();
        state.loading = false;
        state.error = error.message || error;
        state.finished = true;
        state.answers = answers;
        this.setState(state);
      });
  }

  myIdChange(event) {
    const state = this.copyState();
    state.my_id = event.target.value;
    this.setState(state);
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  reSignIn() {
    this.signOut(() => {
      this.signIn(createGoogleAuthProvider())
    })
  }

  signOut(callback) {
    this.auth().signOut()
      .then(() => {
        const state = this.copyState();
        state.user = null;
        state.my_id = '';
        this.setState(state, callback)
      }).catch(function(error) {
        console.error(error);
        const state = this.copyState();
        state.error = error.message || error;
        this.setState(state);
      });
  }

  async evaluate(row, choice) {
    if (this.useExactEvaluation(row, choice)) {
      return await this.evaluateExact(row, choice)
    }
    return await this.evaluateSmart(row, choice)
  }

  useExactEvaluation(row, choice) {
    if (this.state.evaluation === 'exact') {
      return true
    }
    return !row.some((row, rowIndex) => row.endsWith('|*'))
  }

  async evaluateExact(row, choice) {
    const r = {}
    Object.entries(choice).forEach(c => {
      r[c[0]] = {
        judge: c[1].correct === c[1].answer ? 'correct': 'incorrect',
      }
    })
    // Waiting(Dummy)
    const sleep = msec => new Promise(resolve => setTimeout(resolve, msec))
    await sleep(500)
    return r
  }

  async evaluateSmart(row, choice) {
    const targetsMap = {};
    Object.entries(choice).forEach(c => {
      targetsMap[c[0]] = row
        .map((cell, cellIndex) =>
          cellIndex === parseInt(c[0]) ? c[1].answer :
            (choice[cellIndex] ? choice[cellIndex].correct : cell))
        .join(' ').replace('\n', ' ').trim();
    });
    const correct = row
      .map((cell, cellIndex) =>
        choice[cellIndex] ? choice[cellIndex].correct : cell)
      .join(' ').replace('\n', ' ').trim();

    const targets = [...Object.values(targetsMap)];
    const result = await axios.post("/evaluate/" + this.state.context_id, {
      correct,
      targets: targets,
    });
    console.log('Evaluated', targets, result);
    const r = {}
    Object.entries(choice).forEach(c => {
      const target = targetsMap[c[0]];
      const targetResult = result.data.result[target];
      console.log('Choice', c, target, targetResult);
      r[c[0]] = {
        judge: (targetResult.semantic <= 5 && targetResult.grammar <= 2) ? 'correct': 'incorrect',
        semantic_score: targetResult.semantic,
        grammar_score: targetResult.grammar,
      };
    });
    return r;
  }

  isJustInitialized(context) {
    if (!context.selected || !context.activities || !context.answers) {
      return true
    }
    if (context.selected.rowIndex === 0 && context.selected.beginIndex === 0
      && context.activities.length === 0 && context.answers.length === 0) {
      return true
    }
    return false
  }

  clozev2Store(context) {
    if (this.isJustInitialized(context)) {
      return
    }
    if (this.state.disableLocalStorage) {
      return;
    }
    try {
      setLocalStorageItem(`clozev2.${this.state.task_id}`, JSON.stringify(context))
    } catch (e) {
      const error = `ブラウザへの実施状況の保存に失敗しました: ${e.name}。途中経過は保存されません。`
      console.error(error)
      this.setState({
        error,
      });
    }
  }

  clozev2HintPerform(performed) {
    if (this.state.disableLocalStorage) {
      return;
    }
    const hint = Object.assign({}, this.state.clozev2hint)
    hint[performed] = true
    localStorage.setItem('clozev2.hint', JSON.stringify(hint))
    this.setState({
      clozev2hint: hint
    })
  }

  getImageURL(filename) {
    const imageIndex = filename.endsWith('.dat') ? filename.substring(0, filename.length - 4) : filename
    return `/image/${this.state.task_id}/${this.state.context_id}/${imageIndex}`
  }

  reportTypeChange(ev) {
    const report = Object.assign({}, this.state.report)
    report.type = ev.target.value
    this.setState({
      report,
    })
  }

  reportTextChange(ev) {
    const report = Object.assign({}, this.state.report)
    report.text = ev.target.value
    this.setState({
      report,
    })
  }

  closeReport() {
    this.setState({
      report: null,
    })
  }

  submitReport() {
    const report = Object.assign({}, this.state.report)
    report.submitting = true
    this.setState({
      report,
    }, () => {
      this.log('report.issue', {
        progress: this.state.progress,
        type: this.state.report.type,
        text: this.state.report.text,
      }, () => {
        this.setState({
          report: null,
        })
      })
    })
  }

  wordProblemReported(word) {
    this.log('report.issue', {
      word,
    })
  }

  resetContext() {
    this.setState({
      confirmResettingContext: true,
    }, () => {
      this.performResetContext()
        .then(() => {
          this.setState({
            confirmResetContext: false,
            confirmResettingContext: false,
          }, () => window.location.reload())
        })
        .catch(error => {
          this.showError(error)
        })
    })
  }

  async performResetContext() {
    if (!this.state.disableLocalStorage) {
      localStorage.removeItem(`clozev2.${this.state.task_id}`)
    }
    const taskRef = this.db
      .collection('user').doc(this.state.user.uid)
      .collection('taskref')
      .doc(this.state.task_id)
    await taskRef.delete()
  }

  canAccess(targetUser) {
    if (!this.state.require_auth) {
      return true
    }
    const user = targetUser || this.state.user
    if (!user || !user.email) {
      return false
    }
    const whitelist = (this.state.whitelist_auth || '')
      .split(';').map(d => d.trim()).filter(d => d.length > 0)
    if (whitelist.length === 0) {
      return true
    }
    return whitelist.some(domain => user.email.endsWith(domain))
  }

  toPreviousPage() {
    if (!this.clozev2Ref.current) {
      return
    }
    this.clozev2Ref.current.toPreviousPage()
  }

  toNextPage() {
    if (!this.clozev2Ref.current) {
      return
    }
    this.clozev2Ref.current.toNextPage()
  }

  toFirstPage() {
    if (!this.clozev2Ref.current) {
      return
    }
    this.clozev2Ref.current.toFirstPage()
  }

  toLastPage() {
    if (!this.clozev2Ref.current) {
      return
    }
    this.clozev2Ref.current.toLastPage()
  }

  renderIntroduction() {
    return <div>
      <p>Cloze Testは、一部が空欄になった文章を穴埋めすることで解くスタイルの英語問題です。</p>
      <p>
        <YouTubeLink title="使い方動画(YouTube)" youtubeid="DOT9vOMHols" />
      </p>
    </div>
  }

  renderJumbotron() {
    return <Jumbotron>
      <h1>Cloze Testアプリ</h1>
      {this.renderIntroduction()}
    </Jumbotron>
  }

  linkMatched(location, words, link, pages) {
    if (link.task_id) {
      if (this.state.task_id !== link.task_id) {
        return false;
      }
    }
    if (link.begin) {
      const rowIndex = this.getRowIndexFromQuery(this.parseFilterQuery(link.begin), pages);
      if (rowIndex === null) {
        return false;
      }
      if (this.toAbsoluteRowIndex(location.rowIndex) < rowIndex) {
        return false;
      }
    }
    if (link.end) {
      const rowIndex = this.getRowIndexFromQuery(this.parseFilterQuery(link.end), pages);
      if (rowIndex !== null && this.toAbsoluteRowIndex(location.rowIndex) >= rowIndex) {
        return false;
      }
    }
    if (link.words) {
      const targetWords = words.map((w) => w.split('|')[0]).join(' ');
      if (link.words.toLowerCase() !== targetWords.toLowerCase()) {
        return false;
      }
    }
    return true;
  }

  resolveAdditionalLinks(location, words, links) {
    if (!links) {
      return [];
    }
    let originalTaskData = this.state.data;
    if (this.state.filtered_query) {
      originalTaskData = this.state.filtered_query.originalTaskData || this.state.data;
    }
    const content = new ClozeContent(originalTaskData);
    const pages = content.getPages();
    return links.filter((link) => this.linkMatched(location, words, link, pages));
  }

  requestAdditionalLinks(location, words, callback) {
    if (!callback) {
      return;
    }
    console.log('Additional Links', location, words);
    this.performRequestAdditionalLinks(location, words)
      .then((links) => {
        callback(links);
      })
      .catch(error => {
        console.error(error);
        this.setState({
          error: error.message || error,
        });
        callback([]);
      });
  }

  async performRequestAdditionalLinks(location, words) {
    if (this.state.additionalLinks !== null) {
      return this.resolveAdditionalLinks(location, words, this.state.additionalLinks);
    }
    const { links } = this.query;
    if (!links) {
      return [];
    }
    const data = await axios.get(links);
    console.log('Links', data.data);
    const additionalLinks = (data.data || {}).links || [];
    this.setState({
      additionalLinks,
    });
    return this.resolveAdditionalLinks(location, words, additionalLinks);
  }

  getDurationFromActivities(activities) {
    const allActivities = (activities || [])
      .map((a) => a.activities)
      .reduce((x, y) => x.concat(y), []);
    const totalDuration = computeDuration(allActivities).duration;
    const { duration, last } = computeDuration(allActivities
      .filter((a) => a.time >= this.state.startedTime));
    return {
      total: totalDuration,
      current: duration,
      started: this.state.startedTime,
      last,
    };
  }

  restoreTimerStates() {
    const now = Date.now();
    const activities = ((this.state.clozev2store || {}).activities || [])
      .map((a) => a.activities)
      .reduce((x, y) => x.concat(y), []);
    const elapsedDuration = computeDuration(activities).duration;
    return {
      elapsedStarted: now,
      elapsedLastActionAt: now,
      elapsedDuration,
    };
  }

  refreshLastAction(a) {
    const { answer, activities } = a;
    if (activities) {
      const { duration, last } = computeDuration(activities);
      if (!last) {
        return;
      }
      this.setState({
        elapsedStarted: last,
        elapsedLastActionAt: last,
        elapsedDuration: duration,
      });
      return;
    }
    if (!answer) {
      return;
    }
    const times = answer.filter((t) => t && t.answered).map((t) => t.answered);
    if (times.length === 0) {
      return;
    }
    this.setState({
      elapsedLastActionAt: Math.max(...times),
    });
  }

  renderModals() {
    const reportEditor = <Modal
      data-test-report-modal
      show={this.state.report !== null}
      animation={true}
      onHide={e => this.closeReport()}>
      <Modal.Header closeButton>
        <Modal.Title>問題を報告</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          このページ/文章に関する問題を報告します。
        </p>
        <Form.Group>
          <Form.Label>種別</Form.Label>
          <Form.Control
            data-test-report-type
            as='select'
            disabled={this.state.report && this.state.report.submitting}
            onChange={ev => this.reportTypeChange(ev)}
            value={(this.state.report && this.state.report.type) || ''}>
            <option value=''>選択してください</option>
            <option value='sentence'>問題文に誤り</option>
            <option value='score'>採点結果に誤り</option>
            <option value='other'>その他</option>
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>報告内容</Form.Label>
          <Form.Control
            as='textarea'
            name='text'
            rows='20'
            disabled={this.state.report && this.state.report.submitting}
            placeholder='ここに報告内容を入力してください。'
            onChange={ev => this.reportTextChange(ev)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-report-cancel
          onClick={e => this.closeReport()}>
          キャンセル
        </Button>
        <Button
          variant='danger'
          data-test-report-submit
          disabled={this.state.report && (this.state.report.submitting || (this.state.report.type || '') === '' || (this.state.report.text || '') === '')}
          onClick={e => this.submitReport()}>
          {this.state.report && this.state.report.submitting ? '報告しています...' : '報告'}
        </Button>
      </Modal.Footer>
    </Modal>
    return <div>
      {reportEditor}
      <ResetContextDialog
        show={this.state.confirmResetContext}
        resetting={this.state.confirmResettingContext}
        onClose={() => this.setState({ confirmResetContext: false })}
        onSubmit={() => this.resetContext()}
      />
    </div>
  }

  renderAbortResume() {
    return <div className='PrereadHint'>
      <Badge variant='success' className='PrereadHintHead'>ヒント: アプリを中断するには...</Badge>
      <div className='PrereadHintBody'>
        アプリ メニューの 文(ページ)数 をタップすると、中断ボタンを表示できます。いつでも中断した文から再開することができます。
      </div>
      <img alt='about resume' src='/hint/abort_resume.jpg' className='PrereadHintImage'/>
    </div>
  }

  renderAlerts() {
    return (this.state.alerts || []).map((alert) => <ContentAlert
        key={alert.id}
        variant={alert.variant}
        title={alert.title}
        message={alert.message}
      />)
  }

  toRelativeRowIndex(rowIndex) {
    if (!this.state.filtered_query) {
      return rowIndex;
    }
    let relRowIndex = rowIndex;
    if (this.state.filtered_query.startRowIndex) {
      relRowIndex = Math.max(0, relRowIndex - this.state.filtered_query.startRowIndex);
    }
    if (this.state.filtered_query.endRowIndex) {
      relRowIndex = Math.min(relRowIndex, this.state.filtered_query.endRowIndex - (this.state.filtered_query.startRowIndex || 0) - 1);
    }
    return relRowIndex;
  }

  toAbsoluteRowIndex(rowIndex) {
    if (!this.state.filtered_query) {
      return rowIndex;
    }
    if (!this.state.filtered_query.startRowIndex) {
      return rowIndex;
    }
    return rowIndex + this.state.filtered_query.startRowIndex;
  }

  toRelativeAnswersOrActivities(a) {
    if (!a) {
      return a;
    }
    if (!this.state.filtered_query) {
      return a;
    }
    let target = a;
    if (this.state.filtered_query.startRowIndex) {
      target = target.filter((elem) => elem.rowIndex >= this.state.filtered_query.startRowIndex);
    }
    if (this.state.filtered_query.endRowIndex) {
      target = target.filter((elem) => elem.rowIndex < this.state.filtered_query.endRowIndex);
    }
    return target.map((elem) => Object.assign({}, elem, { rowIndex: this.toRelativeRowIndex(elem.rowIndex) }));
  }

  toAbsoluteAnswersOrActivities(a) {
    if (!a) {
      return a;
    }
    if (!this.state.filtered_query) {
      return a;
    }
    return a.map((elem) => Object.assign({}, elem, { rowIndex: this.toAbsoluteRowIndex(elem.rowIndex) }));
  }

  toAbsoluteContext(context) {
    if (!context) {
      return context;
    }
    if (!this.state.filtered_query) {
      return context;
    }
    const newContext = Object.assign({}, context);
    if (context.selected) {
      newContext.selected = Object.assign({}, context.selected, {
        rowIndex: context.selected.rowIndex !== undefined ? this.toAbsoluteRowIndex(context.selected.rowIndex) : undefined,
      });
    }
    if (context.activities) {
      newContext.activities = this.toAbsoluteAnswersOrActivities(context.activities);
    }
    if (context.answers) {
      newContext.answers = this.toAbsoluteAnswersOrActivities(context.answers);
    }
    return newContext;
  }

  ignoredRange() {
    if (!this.state.filtered_query) {
      return null;
    }
    if (this.state.filtered_query.filter) {
      return null;
    }
    return {
      beginRowIndex: this.state.filtered_query.ignoredStartRowIndex,
      endRowIndex: this.state.filtered_query.ignoredEndRowIndex,
    };
  }

  renderMain() {
    const useApp = this.query.ios === '1' || (navigator.userAgent || '').includes('Cloze Test App')
    const toClozeTest = <div className='Suggestion'>
      <a href={`?task_id=${this.state.task_id}&v2=1`}>Cloze Test</a>をして、自分自身で文章を作成できるか、試してみましょう！
    </div>
    const toClozeTestOrQuiz = <div className='Suggestion'>
      単語に自信がなければ、<a href={`?task_id=${this.state.task_id}&quiz=1`}>単語クイズ</a>を、
      単語を覚えたら、<a href={`?task_id=${this.state.task_id}&v2=1`}>Cloze Test</a>に再チャレンジしてみましょう！
    </div>

    return <div>
      <SideNavbar
        theme={this.state.theme}
        user={this.state.user}
        open={this.state.started && !this.state.finished && !this.state.quiz && !this.state.selfeval}
        progress={this.state.finished ? null : this.state.progress}
        abortable={!this.state.exp}
        hasResetContext={this.state.started}
        hasPreviousPage={this.state.pageState && this.state.pageState.hasPreviousPage}
        hasNextPage={this.state.pageState && this.state.pageState.hasNextPage}
        hasFirstPage={this.state.pageState && this.state.pageState.hasPreviousPage}
        hasLastPage={this.state.pageState && this.state.pageState.hasNextPage}
        incompleteTasks={this.state.incompleteTasks !== null ? this.state.incompleteTasks.filter(task => task.id !== this.state.task_id) : null}
        hint={this.state.clozev2hint}
        onHintPerform={performed => this.clozev2HintPerform(performed)}
        onReportIssue={() => this.setState({
          report: {},
        })}
        onSignOut={() => this.signOut()}
        onAbort={() => this.abort()}
        onPreviousPage={() => this.toPreviousPage()}
        onNextPage={() => this.toNextPage()}
        onFirstPage={() => this.toFirstPage()}
        onLastPage={() => this.toLastPage()}
        onResetContext={() => this.setState({ confirmResetContext: true })}
      />
      <TimeNavbar
        open={this.state.started && !this.state.finished && !this.state.quiz && !this.state.selfeval}
        started={this.state.elapsedStarted}
        baseDuration={this.state.elapsedDuration}
        lastActionAt={this.state.elapsedLastActionAt}
      />
      {!this.state.started && this.state.task_id ?
        <div>
          {this.state.title ? <Jumbotron>
            <h1>{this.state.title}</h1>
          </Jumbotron> : ''}
          {(this.state.description && !this.state.autoStart) ? <div className='Description'>
            <Description markdown={this.state.description} />
          </div> : ''}
          {!this.state.user ? <Form.Control
            data-test-my-id
            placeholder='開始するにはあなたの名前を入力してください'
            value={this.state.my_id}
            ref={c => (this._input = c)}
            onChange={ev => this.myIdChange(ev)}/> : ''}
        </div> : ''}
      {this.state.task_id && this.state.reader && !this.state.needAgreement &&
        (this.state.finished ? <div className='Result'>
            <div>
              英文は理解できましたか？
            </div>
            {toClozeTestOrQuiz}
          </div> :
          <ClozeReader
            task={this.state.task_id}
            context={this.state.context_id}
            data={this.state.data}
            ready={this.state.my_id.length > 0}
            imageURL={filename => this.getImageURL(filename)}
            onStatementOpen={(words) => this.log('clozereader', { type: 'sentence', words })}
            onWordsOpen={(words) => this.log('clozereader', { type: 'words', words })}
            onJpTranslateRequest={(words) => this.log('clozereader', { type: 'translate', words })}
            onEnDictRequest={(word) => this.log('clozereader', { type: 'dictionary', word })}
            onJaDictRequest={(word) => this.log('clozereader', { type: 'dictionary/ja', word })}
            onGoogleSearch={(words, callback) => this.log('clozereader', { type: 'googlesearch', words }, callback)}
            onStart={() => this.start()}
            onFinish={() => this.finish('clozereader', { type: 'close' })}/>)}
      {this.state.task_id && this.state.quiz && !this.state.needAgreement &&
        (this.state.finished ? <div className='Result'>
            <div>
              終わりです！<br/>
              {this.state.answers && this.state.answers.summary}
            </div>
            {toClozeTest}
            <ContentLinks
              index={this.state.links ? this.state.links.index : null}
              next={this.state.links ? this.state.links.next : null}
            />
            <Footer />
          </div> : <Quiz
            data={this.state.data.quiz}
            examples={this.state.data.examples}
            disableAudio={true}
            disableStart={this.state.my_id.length === 0}
            hideTitle={true}
            hideCaution={true}
            onStart={() => this.start()}
            onFinish={answers => this.finish('quiz', answers)}
            problemReported={(w) => this.wordProblemReported(w)}
          />)}
      {this.state.task_id && this.state.selfeval && !this.state.needAgreement &&
        (this.state.finished ? <div className='Result'>
            <div>
              終わりです！<br/>
              {this.state.answers && this.state.answers.summary}
            </div>
            {toClozeTest}
            <ContentLinks
              index={this.state.links ? this.state.links.index : null}
              next={this.state.links ? this.state.links.next : null}
            />
            <Footer />
          </div> : <SelfEval
            data={this.state.data.quiz}
            examples={this.state.data.examples}
            disableAudio={true}
            disableStart={this.state.my_id.length === 0}
            hideTitle={true}
            hideCaution={true}
            onStart={() => this.start()}
            onFinish={answers => this.finish('selfeval', answers)}
            problemReported={(w) => this.wordProblemReported(w)}
          />)}
      {this.state.task_id && this.state.v2 && !this.state.needAgreement &&
        (this.state.finished ? <div className='Result'>
            {this.state.exp &&
              <div>
                Cloze Testはこれで完了です！ありがとうございました！
              </div>}
            {!this.state.exp &&
              <div>
                {this.state.score && <div className='ScoreReport'>
                  {this.state.score.scoreTotal}問中 {this.state.score.score}問 正解しました！
                </div>}
                <div>
                  {this.state.aborted && <div className='Aborted'>
                    中断しました！<br/>
                    <a href='/recent/'>最近参照した問題</a>からいつでも回答を再開できます。<br/>
                    <br/>
                    または、別のデバイスでQRコードをスキャンして再開することもできます。<br/>
                    <div className='QRCodeResume'>
                      <QRCode value={ window.location.href } />
                    </div>
                  </div>}
                  英文は理解できましたか？
                </div>
                {toClozeTestOrQuiz}
                <ContentLinks
                  index={this.state.links ? this.state.links.index : null}
                  next={this.state.links ? this.state.links.next : null}
                />
                <Footer />
              </div>}
          </div> :
          <div>
            {!this.state.needAgreement && <BidirectionalTest
              isRightToLeft
              minRate={0.85}
              ref={this.clozev2Ref}
              task={this.state.task_id}
              context={this.state.context_id}
              data={this.state.data}
              ready={this.state.my_id.length > 0}
              autoStart={this.state.autoStart}
              evaluate={this.state.cloze_selection ? null : ((row, choice) => this.evaluate(row, choice))}
              imageURL={filename => this.getImageURL(filename)}
              selected={this.state.clozev2store ? this.toRelativeRowIndex(this.state.clozev2store.selected) : null}
              answers={this.state.clozev2store ? this.toRelativeAnswersOrActivities(this.state.clozev2store.answers) : null}
              activities={this.state.clozev2store ? this.toRelativeAnswersOrActivities(this.state.clozev2store.activities) : null}
              prereadTextClass={this.state.exp ? 'PrereadText' : null}
              otherTextClass={this.state.exp ? 'OtherText' : null}
              disableWordClick={this.state.disable_word_click}
              imageControlClass={useApp ? 'AppImageControl' : null}
              ignored={this.ignoredRange()}
              hint={this.state.clozev2hint}
              onAdditionalLinksRequest={(location, words, callback) => this.requestAdditionalLinks(location, words, callback)}
              onHintPerform={performed => this.clozev2HintPerform(performed)}
              onStatementOpen={(words, context, progress) => this.statementOpen(words, context, progress)}
              onEvaluated={context => this.evaluated(context)}
              onStart={() => this.start()}
              onFinish={(answers, activities) => this.finish('clozereaderv2', {
                type: 'finished',
                answers: this.toAbsoluteAnswersOrActivities(answers),
                activities: this.toAbsoluteAnswersOrActivities(activities),
                duration: this.getDurationFromActivities(activities),
              })}
              onPageStateChange={props => {
                console.log('PageState', props)
                this.setState({
                  pageState: props,
                }
              )}}
              onActivitiesAdded={(activities) => this.refreshLastAction({ activities })}
              onAnswersAdded={(answers) => this.refreshLastAction(answers)}
              readyMessage={this.state.evaluation === 'exact' ? '今から、この英文を、原文の単語あてクイズをしながら読んでみましょう！' : null}
              questionMessage={this.state.evaluation === 'exact' ? '原文はどんな文章か、考えてみよう！' : null}
              prereadMessage={(this.state.clozev2hint && this.state.clozev2hint.abort_resume) ?
                null : this.renderAbortResume()}
            />}
            {(!this.state.started && !this.state.autoStart) && <div className='QRCode'>
                <QRCode value={ window.location.href } />
                <div className='QRCodeDescription'>QRコードをスキャンして別のデバイスで実施</div>
                <ContentLinks
                  index={this.state.links ? this.state.links.index : null}
                  previous={this.state.links ? this.state.links.previous : null}
                />
              </div>}
          </div>)}
      {this.state.task_id && !(this.state.reader || this.state.quiz || this.state.selfeval || this.state.v2) && !this.state.needAgreement &&
        <div>
          <ClozeTest
            context={this.state.context_id}
            data={this.state.data}
            ready={this.state.my_id.length > 0}
            evaluate={this.state.cloze_selection ? null : ((row, choice) => this.evaluate(row, choice))}
            onStart={() => this.start()}
            onFinish={answers => this.finish(`clozetest${this.state.cloze_selection ? '.selection' : ''}`, answers)}/>
          {this.state.finished && <div className='Result'>
            {toClozeTestOrQuiz}
          </div>}
        </div>}
      {(this.state.task_id && !this.state.started && !this.state.autoStart) &&
        (this.state.alerts && this.state.alerts.length > 0 && !this.state.needAgreement) &&
        <div className='AlertMargin'></div>}
      {(this.state.task_id && !this.state.started && !this.state.needAgreement && !this.state.autoStart) && this.renderAlerts()}
      {!this.state.started && this.state.agreement &&
        <Agreement
          db={this.db}
          storage={this.storage}
          user={this.state.user}
          agreement={this.state.agreement}
          needAgreement={this.state.needAgreement}
          userAgreement={this.state.userAgreement}
          onChange={(newNeedAgreement, newUserAgreement) => this.setState({
            userAgreement: newUserAgreement,
            needAgreement: newNeedAgreement,
          })}
          onError={(error) => this.showError(error)}
        />}
      {this.state.task_id && !this.state.started && <div>
          {!this.state.autoStart && <div className='ClozeTestLink'>
            <a
              href='https://youtu.be/DOT9vOMHols'
              target='_blank'
              rel='noopener noreferrer'
            >使い方動画(YouTube)</a><span className='LinkSeparator'>|</span>
            {this.state.importable && <span><a
              href={`/dashboard/import/${this.state.task_id}`}
              target='_blank'
              rel='noopener noreferrer'
            >この問題を自分のアカウントにコピーして利用する</a><span className='LinkSeparator'>|</span></span>}
            <a href='/dashboard/' target='_blank'>自分専用のCloze Testを作ってみる(ダッシュボード)</a><span className='LinkSeparator'>|</span>
            <a href='/notice/' target='_blank'>利用上の注意(対応ブラウザ)</a><span className='LinkSeparator'>|</span>
            <a href='/inquiry/' target='_blank'>お問い合わせ</a>
          </div>}
          <Footer noApp={this.state.autoStart}/>
        </div>}
      {!this.state.task_id && <div>
          {this.renderJumbotron()}
          {this.renderAlerts()}
          <h2>好きな英文で英語学習</h2>
          <p>
            {this.state.taskError !== null && <div className='Error'>
              <div>{this.state.taskError}</div>
              <div>(配布されたURLをご確認ください。)</div>
            </div>}
            Cloze Testアプリを使うと、好きな英文で自由に英語学習を行うことができます。<br/>
            <br/>
            Cloze Testアプリで問題を作成、英語学習を始めたい場合は <a href='/dashboard/'>ダッシュボード</a> を開いてください。
          </p>
          <Footer />
        </div>}
    </div>
  }

  render() {
    return <div>
      <UserNavbar
        theme={this.state.theme}
        user={this.state.user}
        open={!this.state.started || this.state.finished}
        progress={this.state.finished ? null : this.state.progress}
        abortable={!this.state.exp}
        noContext={this.state.autoStart}
        hasResetContext={this.state.started}
        hasPreviousPage={this.state.pageState && this.state.pageState.hasPreviousPage}
        hasNextPage={this.state.pageState && this.state.pageState.hasNextPage}
        hasFirstPage={this.state.pageState && this.state.pageState.hasPreviousPage}
        hasLastPage={this.state.pageState && this.state.pageState.hasNextPage}
        incompleteTasks={this.state.incompleteTasks !== null ? this.state.incompleteTasks.filter(task => task.id !== this.state.task_id) : null}
        onReportIssue={() => this.setState({
          report: {},
        })}
        onSignOut={() => this.signOut()}
        onAbort={() => this.abort()}
        onPreviousPage={() => this.toPreviousPage()}
        onNextPage={() => this.toNextPage()}
        onFirstPage={() => this.toFirstPage()}
        onLastPage={() => this.toLastPage()}
        onResetContext={() => this.setState({ confirmResetContext: true })}
      />
      <div className={`App ${(this.state.started && !this.state.finished) ? ((!this.state.quiz && !this.state.selfeval) ? 'AppTask' : 'AppQuiz') : ''}`}>
        {this.state.loading ?
          <div className='Loading'>
            <ClipLoader />
            <div data-testid='loading'>Loading...</div>
          </div> :
          (this.state.require_auth && !this.state.user ?
            <div>
              <Jumbotron>
                <h1>{this.state.title}</h1>
                <SignInButtons
                  description='このアプリを使用するためには、'
                  option={this.state.whitelist_auth && <div className='DomainWhitelist'>
                      【ご注意】認証はGoogleアカウント <strong>{this.query.domain || this.state.whitelist_auth}</strong> を使用してください。
                    </div>}
                  signIn={(provider) => this.signIn(provider)}
                />
              </Jumbotron>
              <h2>Cloze Testアプリ</h2>
              {this.renderIntroduction()}
            </div> :
            (this.state.require_auth && this.state.user && this.state.whitelist_auth && !this.canAccess() ?
              <div>
                <UnauthorizedUser
                  query={this.query}
                  title={this.state.title}
                  whitelist_auth={this.state.whitelist_auth}
                  onSignIn={() => this.reSignIn()}
                />
              </div> :
              this.renderMain()))}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
      </div>
      {this.renderModals()}
    </div>
  }
}

export default App;
